export default __webpack_public_path__ + "static/media/resume.2b2e3a7c.pdf";